import { prop } from "ramda";
import { localUserDB } from "~/libs/pouch";

const db = localUserDB;

const PouchStorage = {
  getItem: key =>
    db
      .putIfNotExists(key, { state: {} })
      .then(() => db.get(key).then(prop("state"))),
  removeItem: key => db.get(key).then(db.remove),
  setItem: (key, item) =>
    db.get(key).then(doc =>
      db.put({
        _id: key,
        _rev: prop("_rev", doc),
        state: item
      })
    )
};

export default PouchStorage;
